/**
 * @module lib/appserver/entityHeaders/schoolLinked
 * Common interface for all entities which link to schools.
 * These entties will have their IDs scoped by their schoolID.
 */

import { aggregateEntityID } from "lib/appserver/aggregate";
import * as common from "lib/appserver/entityHeaders/common";

export const defaultProperties = {
  ...common.defaultProperties
}

export function appserverAdapter(rawEntity) {
  const props = common.appserverAdapter(rawEntity);
  props.id = aggregateEntityID(props);
  return props;
}



// WEBPACK FOOTER //
// ./src/lib/appserver/entityHeaders/schoolLinked.js